module.exports = __webpack_public_path__ + "img/1529198131.22417aba.jpg";